import { render, staticRenderFns } from "./technicalParameter.vue?vue&type=template&id=1f98e839&scoped=true&"
import script from "./technicalParameter.vue?vue&type=script&lang=js&"
export * from "./technicalParameter.vue?vue&type=script&lang=js&"
import style0 from "./technicalParameter.vue?vue&type=style&index=0&id=1f98e839&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98e839",
  null
  
)

export default component.exports